"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLocaleFlow = changeLocaleFlow;

var _effects = require("redux-saga/effects");

var types = _interopRequireWildcard(require("./types"));

var actions = _interopRequireWildcard(require("./actions"));

var _actions2 = require("../apiFlow/messages/actions");

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(localeWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(changeLocaleFlow);

function localeWorker(action) {
  var locale;
  return regeneratorRuntime.wrap(function localeWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          locale = action.payload.locale;
          _context.next = 3;
          return (0, _effects.put)(actions.set(locale));

        case 3:
          _Utils["default"].setMomentLocale(locale);

          _context.next = 6;
          return (0, _effects.put)((0, _actions2.saga)(locale));

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function changeLocaleFlow() {
  return regeneratorRuntime.wrap(function changeLocaleFlow$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, localeWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}